import { AppShell, DatePickerProvider, LinkProvider, SideNav, Text } from '@ui';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';
import { QuickActions } from '../features/apiary/components/QuickActions';
import { UserMenu } from '../features/identity/components/UserMenu';
import { useMeta } from '../features/system/useMeta';
import { PwaNotices } from '../features/pwa/PwaNotices';
import { WhatsNewDialog } from '../features/system/WhatsNewDialog';
import { Brand } from './Brand';
import { MORE_PATH, useAppNavigation } from './navigation';
import { RouterLink } from './RouterLink';

export function AppLayout() {
  const { t } = useTranslation();
  const meta = useMeta();

  const { items, tabs, moreActive } = useAppNavigation();

  return (
    <LinkProvider component={RouterLink}>
      <DatePickerProvider placeholder={t('common.datePlaceholder')}>
        <AppShell
          brand={<Brand business={meta.data?.business_name} />}
          topbarBrand={<Brand />}
          labels={{
            skipToContent: t('shell.skipToContent'),
            openMenu: t('shell.openMenu'),
            closeMenu: t('shell.closeMenu'),
            more: t('shell.more'),
            tabs: t('shell.tabs'),
          }}
          tabs={tabs}
          more={{ href: MORE_PATH, active: moreActive }}
          headerActions={<QuickActions />}
          navigation={(close) => <SideNav label={t('nav.main')} items={items} onNavigate={close} />}
          sidebarFooter={(close) => (
            <>
              <UserMenu onNavigate={close} />
              {meta.isError && (
                <Text as="p" size="xs" tone="danger" role="status">
                  {t('dashboard.status.offline')}
                </Text>
              )}
            </>
          )}
        >
          <Outlet />
          <WhatsNewDialog />
          <PwaNotices />
        </AppShell>
      </DatePickerProvider>
    </LinkProvider>
  );
}
